<template>
  <div
    v-if="!$i18n.g1"
    :class="{ lang_blocks: asBlocks }"
  >
    <NavCard
      v-for="item in langs"
      :key="item.id"
      :item="{ title: item.name }"
      :isActive="item.id === $i18n.locale"
      :class="itemClass"
      :style="itemStyle"
      @click="selectedLang = item"
    >
      <template #icon>
        <div
          class="lang-svg-flag"
          :class="item.id"
        >
          <component :is="item.flag" />
        </div>
      </template>
    </NavCard>
  </div>
</template>

<script>
import lang_mix from '@/components/LangSwitcher/lang_mix'
import NavCard from '@/components/NavCard/NavCard'

export default {
  name: 'LangSwitcher',
  components: { NavCard },
  mixins: [lang_mix],
  props: {
    asBlocks: Boolean,
    itemStyle: {
      type: String,
      default: () => '--height: 3rem; --clr-tag-back: var(--clr-black-4)',
    },
    itemClass: {
      type: String,
      default: () => '',
    },
  },
}
</script>
<style lang="scss" scoped>
.lang-svg-flag {
  height: inherit;
  width: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  fill: black;
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &.ko {
    background: white;
  }
  &.tteam {
    background: var(--clr-yellow);
  }
}

.lang_blocks {
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex: 1;
  width: 100%;
  grid-gap: 0.5rem;
}

@media (hover: hover) and (pointer: fine) {
  .lang_blocks {
    &_block {
      &:hover {
        background: var(--clr-black-2);
        cursor: pointer;
      }
    }
  }
}
</style>
